import { CssBaseline, ThemeProvider, createTheme } from '@mui/material'
import React from 'react'
import createEmotionCache from '../utils/createEmotionCache'
import { CacheProvider } from '@emotion/react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { routes } from '../routes/routes'
import { AuthProvider } from '../context/AuthContext/AuthContext'
import ProtectedRoute from '../routes/ProtectedRoute'
import LoginPage from '../pages/auth/LoginPage'
import NotFound from '../pages/notFound/NotFound'
import LogoutPage from '../pages/auth/LogoutPage'
import RegisterPage from '../pages/auth/RegisterPage'
import { globalTheme } from '../utils/theme/theme'

// import font face
import '@fontsource/open-sans'
import SigninlySilent from '../routes/SigninlySilent'
import Layouts from '../layouts/Layouts'
import AppComponent from './AppComponent'
import { QueryClient, QueryClientProvider } from 'react-query'
import { CameraProvider } from '../context/CameraContext/CameraContext'
import { GeolocationProvider } from '../context/GeolocationContext/GeolocationContext'
import { LoggingProvider } from '../context/LoggingContext/LoggingContext'

const emotionCache = createEmotionCache()
const queryClient = new QueryClient()
const App = () => {
  const theme = createTheme({
    palette: {
      mode: 'light',
      ...globalTheme.palette,
    },
    typography: {
      ...globalTheme.typography,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '10px',
          },
        },
      },
    },
  })

  function getRoutes() {
    return routes.map((route) => {
      return (
        <Route key={route.path} element={<AppComponent layout={route.layout} />}>
          <Route path={route.path} element={route.element} />
        </Route>
      )
    })
  }
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CacheProvider value={emotionCache}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
              <GeolocationProvider>
                <CameraProvider>
                  <LoggingProvider>
                    <Routes>
                      <Route element={<Layouts />}>
                        <Route element={<ProtectedRoute />}>{getRoutes()}</Route>
                        <Route element={<SigninlySilent />}>
                          <Route path="login" element={<LoginPage />} />
                          <Route path="register" element={<RegisterPage />} />
                        </Route>
                        <Route path="logout" element={<LogoutPage />} />
                        <Route path="/" element={<Navigate to={'home'} replace />} />
                        <Route path="*" element={<NotFound />} />
                      </Route>
                    </Routes>
                  </LoggingProvider>
                </CameraProvider>
              </GeolocationProvider>
            </BrowserRouter>
          </ThemeProvider>
        </CacheProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App
